import React from 'react';
import { FiChevronRight } from 'react-icons/fi';

const Breadcrumb = ({ items, onClick }) => (
  <nav className="flex items-center gap-2 text-sm text-gray-999 pb-4 pl-4">
    {items.map((item, index) => (
      <React.Fragment key={index}>
        {index > 0 && <FiChevronRight size={14} />}
        {item.path ? (
          <button
            onClick={() => onClick(item.path, index)}
            className="hover:mph-primary hover:underline font-semibold"
          >
            {item.name}
          </button>
        ) : (
          <span className="text-emerald-600">{item.name}</span>
        )}
      </React.Fragment>
    ))}
  </nav>
);

export default Breadcrumb;
